
export var horizontalValues = ['', 'left', 'center', 'right', 'start', 'end'];
export var verticalValues = ['', 'top', 'center', 'bottom', 'hanging', 'middle', 'alphabetic', 'ideographic'];

var isHorizontal = function (value) { return horizontalValues.indexOf(value) > -1; };
var isVertical = function (value) { return verticalValues.indexOf(value) > -1; };

export default function normalizeAlignment(alignment) {
    if (typeof alignment === 'string') {
        alignment = alignment.trim().split(/\-/);
    }
    var first = alignment[0];
    var second = alignment[1];
    if (isHorizontal(first) && isVertical(second)) {
        return [first, second];
    }
    if (isVertical(first) && isHorizontal(second)) {
        return [second, first];
    }
    throw new Error(("Illegal alignment, bad mix of values or unknown value in: " + first + ", " + second));
};



// WEBPACK FOOTER //
// ./src/libs/normalize-alignment.js